import { UPDATE_WAS_LEAD_CAPTURE_FORM_FILLED } from '../actions';

export function wasLeadCaptureFormFilled(state = false, action) {
  switch (action.type) {
    case UPDATE_WAS_LEAD_CAPTURE_FORM_FILLED: {
      return action.wasLeadCaptureFormFilled;
    }
    default:
      return state;
  }
}
